import { Body, Controller, Get, Put, Req, UseGuards } from '@nestjs/common';
import { ApiBearerAuth, ApiSecurity, ApiTags } from '@nestjs/swagger';
import { UpdateEmailSettingsRequest } from '@cart/shared-types';
import { AdminAccessGuard } from '../auth/admin-access.guard';
import { AuthGuard, GuardedRequest } from '../auth/auth.guard';
import { EmailSettingsService } from './email-settings.service';

@ApiTags('Admin · Templates')
@ApiBearerAuth()
@ApiSecurity('store-id')
@Controller('admin/email-settings')
@UseGuards(AuthGuard, AdminAccessGuard)
export class EmailSettingsController {
  constructor(private readonly emailSettingsService: EmailSettingsService) {}

  @Get()
  get() {
    return this.emailSettingsService.get();
  }

  @Put()
  update(@Body() body: UpdateEmailSettingsRequest, @Req() req: GuardedRequest) {
    return this.emailSettingsService.update(body, req.user.id);
  }
}
